
export { XhrClient } from './lib/XhrClient';


// WEBPACK FOOTER //
// ./src/packages/http/index.ts